import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./SocialPostSkeleton.module.scss";

const SocialPostSkeleton = ({ count = 1 }) => {
  return (
    <section className={styles.socialPostSkeleton}>
      {Array.from({ length: count }).map((_, index) => (
        <div className={styles.skeletonPost} key={index}>
          {/* Header */}
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <Skeleton circle width={40} height={40} />
              <div className={styles.headerText}>
                <Skeleton width={120} height={12} />
              </div>
            </div>

            <div className={styles.headerRight}>
              {/* <Skeleton width={80} height={20} /> */}
            </div>
          </div>

          {/* Text Content */}
          <div className={styles.textContent}>
            <Skeleton count={2} height={10} />
          </div>

          {/* Image */}
          <div className={styles.image}>
            <Skeleton height={120} />
          </div>

          {/* Footer (likes/comments/share) */}
          <div className={styles.footer}>
            <Skeleton width={50} height={20} />
            <Skeleton width={50} height={20} />
            {/* <Skeleton width={60} height={20} /> */}
          </div>
        </div>
      ))}
    </section>
  );
};

export default SocialPostSkeleton;
